import { RESET_STATE } from '@redux-offline/redux-offline/lib/constants';
import { createAction } from '@reduxjs/toolkit';

export const resetOfflineQueueState = createAction(RESET_STATE);
